// https://srini-dev.hashnode.dev/authentication-refresh-token-flow-with-nextjs-typescript-react-query-and-axios-interceptors
import axios from 'axios'
import { flashError } from '../core/utils/flashMessage'
import history from '../core/utils/history'

import { APP_VERSION, API, defaultSubdomian } from '../config/const'

const jwtDecode = require('jwt-decode')

export const apiUrl = (subdomain, path) => {
  const base = apiBaseUrl(subdomain)

  return `${base}${path}`
};

export const apiBaseUrl = (subdomain) => {
  return API.replace('https://', `https://${subdomain}.`)
};
/**
 * TODO: Esto puede devolver -api, si estamos en el caso de app.radixtool.com
 */
export function getPublicHttpClient () {
  const api = axios.create()

  let subdomain = window.location.host.split('.')[1]
    ? window.location.host.split('.')[0]
    : false
  subdomain = subdomain === defaultSubdomian ? '' : subdomain

  const burl = apiBaseUrl(subdomain)

  api.defaults.baseURL = burl
  api.defaults.headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }

  return api
}

export function getHttpClient () {
  const api = axios.create()
  let subdominio = ''

  if (window.localStorage.getItem('subdominio')) {
    subdominio = window.localStorage.getItem('subdominio')
  } else {
    subdominio = window.location.host.split('.')[1]
      ? window.location.host.split('.')[0]
      : false
    subdominio = subdominio === defaultSubdomian ? '' : subdominio
  }
  const burl = apiBaseUrl(subdominio)

  api.defaults.baseURL = burl

  api.interceptors.request.use(
    (config) => {
      const token = window.localStorage.getItem('access-token')
      if (token) {
        // Configure this as per your backend requirements
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  api.interceptors.response.use(
    (res) => {
      return res
    },
    async (err) => {
      const originalConfig = err.config
      if (originalConfig.url !== '/user/login' && err.response) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true
          try {
            const refreshToken = window.localStorage.getItem('refresh-token')
            const response = await axios.post(
              `${burl}token/refresh?v=${APP_VERSION}`,
              { refresh_token: refreshToken },
              { 'Content-Type': 'application/json' }
            )

            const access = response.data.token
            const refresh = response.data.refresh_token

            const decoded = jwtDecode(response.data.token)

            window.localStorage.setItem('roles', decoded.roles)
            window.localStorage.setItem('access-token', access)
            window.localStorage.setItem('refresh-token', refresh)

            return api(originalConfig)
          } catch (_error) {
            flashError({
              title: 'Su sesión ha expirado',
              description:
                'Lo sentimos pero su sesión ha caducado, por favor vuelva a ingresar.',
            })
            // Logging out the user by removing all the tokens from local
            window.localStorage.removeItem('roles')
            window.localStorage.removeItem('access-token')
            window.localStorage.removeItem('refresh-token')
            // Redirecting the user to the landing page

            history.push('/auth/login')
            // window.location.href = `${window.location.origin}/auth/login`
            return Promise.reject(_error)
          }
        }
      }

      return Promise.reject(err)
    }
  )

  return api
}
